module.exports = __webpack_public_path__ + "img/profile_policies.22641176.png";